import React, { useState, useEffect } from 'react';
import { Globe, AlertTriangle } from 'lucide-react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

const API_URL = process.env.REACT_APP_API_URL || 'https://monitoring.leetcode.uz/api';

function BrowserSummary() {
  const [categories, setCategories] = useState({});

  useEffect(() => {
    loadData();
    const interval = setInterval(loadData, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadData = async () => {
    try {
      const response = await axios.get(`${API_URL}/browser/categories`);
      setCategories(response.data.data);
    } catch (err) {
      console.error('Failed to load browser summary:', err);
    }
  };

  const highRiskCategories = Object.entries(categories)
    .filter(([cat]) =>
      ['job_search', 'competitor', 'personal_email', 'cloud_storage'].includes(cat)
    )
    .sort((a, b) => b[1].total_risk - a[1].total_risk)
    .slice(0, 3);

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Globe className="h-4 w-4 text-primary" />
          Browser Activity
        </CardTitle>
      </CardHeader>
      <CardContent>
        {highRiskCategories.length > 0 ? (
          <ul className="flex flex-col gap-2">
            {highRiskCategories.map(([cat, data]) => (
              <li key={cat} className="flex flex-col gap-1">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-foreground">
                    {cat.replace('_', ' ').toUpperCase()}
                  </span>
                  <Badge variant="destructive">
                    <AlertTriangle className="h-3 w-3" />
                    {data.count}
                  </Badge>
                </div>
                <span className="text-xs text-muted-foreground">Risk: {data.total_risk}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-muted-foreground">No high-risk browsing detected</p>
        )}
      </CardContent>
    </Card>
  );
}

export default BrowserSummary;
